// Smart back: return to the actual previous page; fall back to the list when
// the app was opened directly on a detail page (no in-app history).
export const goBack = (nav, fallback) => {
  if (window.history.state && window.history.state.idx > 0) nav(-1);
  else nav(fallback, { replace: true });
};
